export const CONTACT = {
  phone: "+92 324 5325357",
  whatsapp: "923245325357",
  whatsappUrl: "https://wa.me/923245325357",
  email: "masknah2023@gmail.com",
  website: "https://maskanh.com",
  facebook: "https://www.facebook.com/profile.php?id=61575977741836",
  instagram:
    "https://www.instagram.com/maskanhofficial?utm_source=ig_web_button_share_sheet&igsh=bmR6Z3hmdTg0M2M4",
  linkedin: "https://www.linkedin.com/in/maskanh-inc-679b70282/",
  privacyPolicy: "/privacy-policy",
  terms: "/terms-and-conditions",
  blogs: "/blogs",
};
